 <div class="d-flex justify-content-center flex-column align-items-center">
   <div class="d-flex flex-row">
     <img [style.width]="img_width" [style.height]="img_width"  *ngIf="icon_code!='' && icon_code!=undefined"
          src="{{'./assets/resource/status/'+ icon_code+'.png'}}">
     <img [style.width]="img_width" [style.height]="img_width" *ngIf="icon_code==undefined" class="image-notfound"
          >

   </div>
   <span class="text-1424 d-sm-block d-none">
     {{description}}
   </span>
 </div>
